module.exports = __webpack_public_path__ + "img/ic-filter-active.d24e88be.svg";